import { render, staticRenderFns } from "./right-toolbar.component.vue?vue&type=template&id=4c8b7138&scoped=true&"
import script from "./right-toolbar.component.vue?vue&type=script&lang=js&"
export * from "./right-toolbar.component.vue?vue&type=script&lang=js&"
import style0 from "./right-toolbar.component.vue?vue&type=style&index=0&id=4c8b7138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b7138",
  null
  
)

export default component.exports